import { apiUtils } from '../utils/apiUtils'

const jsonHeaders = { 'Content-Type': 'application/json' }

export default {
  upsert: function (code, notilus, step) {
    return fetch(apiUtils.integrationEnroll + '/notilus/' + code + '/' + step, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(notilus)
    })
  },
}
